export const URL_LOGIN = '/login';
export const URL_SIGNUP = '/signup';
export const URL_FORGET_VERIFY = '/forget-verify';

export const URL_COMPANY_CREATE = '/company/create';
export const URL_COMPANY_EDIT = '/company/edit/:id';
export const URL_BENCHMARK_PRICE = '/benchmark-prices';
export const URL_PRODUCT_CREATE = '/product/create';
export const URL_PRODUCT_EXTERNAL = '/external-product';
export const URL_PRODUCT_EXTERNAL_LISTING = '/external-product-listing';
export const URL_PRODUCT_EXTERNAL_CREATE_SUCCESS = '/external-product-success';
export const URL_PRODUCT = '/products';
export const URL_PRODUCT_MARKETPLACE = '/products-marketplace';
// Purchase Form
export const URL_PURCHASE_CREATE = '/purchase/create';

export const URL_DHL_DASHBOARD = '/dhl';
export const URL_RESOURCE = '/resource';
export const URL_RESOURCE_STORE = '/resource-store';
export const URL_SETTINGS = '/settings';
export const URL_EXCHANGE_RATE_SETTINGS = '/exchange-rate-settings';
export const URL_BLACKLIST_KEYWORDS = '/blacklist-keywords';
export const URL_REGIONAL_TAX = '/regional-tax';
export const URL_REGION_CONFIG = '/region-config';
export const URL_ORDER_ITEMS_CATEGORIES = '/order-items-categories';
export const URL_RECEIPT = '/product-receipt';
export const URL_ASYNC_TASK_REPORT = '/async-task-report';
export const URL_PO = '/product-order';
export const URL_PO_V2 = '/product-order-v2';
export const URL_QUOTATIONS = '/quotations';
export const URL_RFQ = '/rfq';
export const URL_RFQ_TO_SUPPLIER = '/rfq-to-supplier';
export const URL_RFQ_FORECAST = '/rfq-forecast';
export const URL_VENDOR = '/vendors';
export const URL_MANUFACTURER = '/manufacturers';
export const URL_PRODUCT_CODE = '/product-unspsc-code';
export const URL_OCI = '/oci';
export const URL_QUICK_CRAWL = '/quick-crawl';
export const URL_USERS = '/users';
export const URL_OVERVIEW = '/overview';
export const URL_ANALYTICS = '/analytics';
export const URL_MONTHLY_ANALYTICS = '/monthly-analytics';
export const URL_GMV_ANALYTICS = '/gmv-analytics';
export const URL_TRACKING_ANALYTICS = '/tracking-analytics';
export const URL_AGING_REPORT = '/aging-report';
export const URL_ANALYTICS_WORLD_MAPS = '/analytics-world-map';
export const URL_ANALYTICS_ACTIVITY_TRACKING = '/analytics-activity-tracking';
export const URL_UPLOAD = '/upload';
export const URL_CARD_REQUEST = '/card-request';
export const URL_ENTITY = '/entity';
export const URL_SUPPLIERS = '/active-suppliers';
export const URL_SUPPLIERS_PENDING = '/pending-suppliers';
export const URL_VENDOR_QUESTIONS = '/vendor-questions';
export const URL_SUPPLIER_SOA = '/suppliers/soa-payment-terms';
export const URL_SUPPLIER_SOA_OUTSTANDING_PAYMENT =
  '/suppliers/soa-outstanding-payment-terms';
export const URL_CUSTOMER_SOA = '/entity/soa-payment-terms';
export const URL_SUPPLIER_SOA_DETAIL = '/suppliers/soa-payment-terms/detail';
export const URL_CUSTOMER_SOA_DETAIL = '/entity/soa-payment-terms/detail';
export const URL_CUSTOMER_SOA_CONSOLIDATED_LIST =
  '/entity/consolidated-soa-list';
export const URL_SUPPLIER_SOA_VCARD = '/suppliers/soa-vcard';
export const URL_SUPPLIER_SOA_VCARD_DETAIL = '/suppliers/soa-vcard/detail';
export const URL_SUPPLIER_QUICK_SOA = '/suppliers/quick-soa-consolidation';

export const URL_SUPPLIER_PAYMENTS = '/supplier-payments';
export const URL_SUPPLIER_PAYMENTS_V2 = '/supplier-payments-v2';
export const URL_PAYMENT_METHODS = '/payment-methods';
/**
 * Create Supplier Payment page for internal mobile version
 */
export const URL_SUPPLIER_PAYMENTS_CREATE = '/supplier-payments/create';
export const URL_REVERT_SUPPLIER_PAYMENT_STATUS =
  '/revert-supplier-payment-status';
export const URL_SOA_PAYMENTS = '/soa-payments';
export const URL_BILLING_PARTIES = '/billing-parties';
export const URL_SUPPLIER_PAYMENTS_GRAPHS = '/supplier-payments/graphs';
export const URL_SUPPLIER_PAYMENTS_DETAILS = '/supplier-payments/:id';
export const URL_XERO_SETTINGS = '/xero-settings';
export const URL_XERO_SYNC_MAPPING = '/xero-sync-mapping';
export const URL_XERO_OAUTH2_CALLBACK = '/oauth2/xero/callback';
export const URL_SYNC_99SME = '/sync-to-99sme';
export const URL_JD_INTEGRATION = '/jd-integration';
export const URL_JD_INVOICE = '/jd-invoice';

export const URL_CREATE_SUPPLIER_VENDOR = '/create-supplier-vendor';
export const URL_CREATE_SUPPLIER_VENDOR_RESULT =
  '/create-supplier-vendor-result';
export const URL_CREATE_SUPPLIER_PAYMENT = '/create-supplier-payment';

export const URL_ORDER_SYNC_TO_XERO = 'orders/sync-to-xero';
export const URL_SP_SYNC_TO_XERO = 'supplier-payments/sync-to-xero';

export const URL_USER_SETTING = '/user-setting';
export const URL_DELETE_PRODUCT = '/delete-product';

// INTERNAL TICKETING
export const URL_TICKETING_SUBMIT = '/ticketing';
export const URL_TICKETING_LIST = '/ticketing-list';

// EXTERNAL TICKETING
export const URL_TICKETING_LIST_EXTERNAL = '/ticketing/list';

// INTERNAL GRN RATING
export const URL_GRN_RATING_LIST = '/grn-list';

// EXTERNAL GRN RATING
export const URL_EXTERNAL_GRN_RATING = '/grn';

// AMAZON ORDERS
export const URL_AMAZON_ORDERS = '/amazon-orders';

export const URL_HOME = URL_TICKETING_LIST;

// THIRD PARTY DELIVERY APP
export const URL_GOODS_DELIVERY = '/goods-delivery';

// SUPPLIER UPDATE DELIVERY DATE
export const URL_SUPPLIER_UPDATE_DELIVERY_DATE = '/vendor-change-delivery-date';

// CONTRACT ANALYZER
export const URL_CONTRACT_LIST = '/contracts';

// S2P PERSONAL DASHBOARD
export const URL_S2P_PERSONAL_DASHBOARD = '/s2p-personal-dashboard';

// SME MARKETPLACE
export const URL_SME_MARKETPLACE = '/sme-marketplace';

// GENERAL CONFIRMATION PAGE
export const URL_GENERAL_CONFIRMATION_PAGE = '/fer';

// PETER NCPR MARKETPLACE
export const URL_PETER_NCPR_MARKETPLACE = '/peter-ncpr-marketplace';

// LINE ITEM ANALYTIC
export const URL_LINE_ITEM_ANALYTIC = '/graphs/line-item-analytic';

// OUTBOUND EMAILS
export const URL_OUTBOUND_EMAILS = '/outbound-emails';
// EMAIL READER
export const URL_EMAIL_READER_ORDER_FROM_MAIL = '/email-reader/order-from-mail';

// API Keys
export const URL_API_KEYS = '/api-keys';
export const URL_API_KEY_ANALYTICS = '/api-key/analytics';
export const URL_PERMISSION_GROUPS = '/permission-groups';

// SPID MARGIN ANOMALY REVIEW
export const URL_MARGIN_ANOMALY_REVIEW = '/margin-anomaly-review';

// ORDER QTY CHECK REVIEW
export const URL_QTY_CHECK_REVIEW = '/qty-check-review';

// INVOICE LOGS
export const URL_ORDER_INVOICE_LOGS = '/order-invoice-logs';
export const URL_ORDER_INVOICE_DETAIL = '/order-invoice/:id';
export const URL_ORDER_INVOICE_PUBLIC = '/share/invoice/:id';
export const URL_BUYER_INVOICING = '/buyer-invoicing';

// CRON TRIGGERS
export const URL_CRON_TRIGGERS = '/cron-triggers';
// NOTIFICATIONS
export const URL_NOTIFICATIONS = '/notifications';
